/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  customerId,
  downlineId,
  drawId,
  systemGameId,
  systemGameTypeId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  DEFAULT,
  DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
} = require('../../scopes');

module.exports = {
  getDrawSystemGameTypeAteVolumeByCustomerId: {
    properties: {
      params: {
        properties: {
          customerId,
          drawId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeAteVolumeRecipesByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeOverallVolumeByCustomerId: {
    properties: {
      params: {
        properties: {
          customerId,
          drawId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeOverallVolumeRecipesByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeReportStrikeOverviewByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeReportVolumeByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeReportVolumeRecipesByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeTankedVolumeByCustomerId: {
    properties: {
      params: {
        properties: {
          customerId,
          drawId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypeTankedVolumeRecipesByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          drawId,
          systemGameTypeId,
        },
        required: [
          'compositeKey',
          'systemGameTypeId',
          'drawId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getDrawSystemGameTypesBySystemGameId: {
    properties: {
      params: {
        properties: {
          drawId,
          systemGameId,
        },
        required: [
          'drawId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        DEFAULT,
        DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  resynchronizeDrawSystemGameTypeContract: {
    properties: {
      body: {
        properties: {
          compositeKey,
          downlineId,
        },
        required: [
          'compositeKey',
          'downlineId',
        ],
        type: 'object',
      },
      params: {
        properties: {
          drawId,
          systemGameTypeId,
        },
        required: [
          'drawId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
    },
    required: ['query'],
    type: 'object',
  },
};
